import React, { Fragment, PureComponent, createRef } from 'react';
import { connect } from 'react-redux';
import { getCookie } from '../../helpers/cookieHelper';
import { Button, Progress, Input, Tabs, Modal } from 'antd'
import { WarningOutlined, CloseCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { onActionFailed, onSetUploadWindowTrigger, onSetToolAction } from '../../reducers/toolLayoutReducer';
import i10n from '../../i10n';
import GooglePicker from './googlePicker';
import DropboxChooser from './dropboxChooser';
import UploadMoreButton from './uploadMoreButton';
import { onFileNeedRedirection, onFileUploaded, onRemoveFile, onReorderUploadedFiles, onGetProcessedContextId, onSetRedirectionInfo, onRemoteFileUploaded, onAddPendingRemoteFile, onRemoveAllFiles } from '../../reducers/uploadFileReducer';
import FileService from '../../services/fileService';
import { steps, redirectionSteps } from '../../../constants/steps';
import Tooltip from '../tooltip';
import tools, { thumbnailMode } from '../../../constants/tools';
import { fileFormats, getFileSizeLimit, getFileType } from '../../helpers/fileHelper';
import config from '../../../config';
import { getFormattedFileSize } from '../../helpers/toolsHelper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faCheck, faTimes, faFile } from '@fortawesome/free-solid-svg-icons';
import { AsyncSVG } from '../AsyncSVG';
import URLChooser from './URLChooser';
import Utilities from '../../../common/helpers/utilities';
import sitemap from '../../sitemap';
import { UserHelper } from '../../helpers/userHelper';
import { getLocalizedLink, ToolStatus } from '../tool';
import { Link } from 'react-router-dom';
import Utilites from '../../../common/helpers/utilities';

const { TabPane } = Tabs;
const { TextArea } = Input;

let uploadInput = null;
export const uploadFileClick = () => {
    UserHelper.RefreshUsage();
    uploadInput.value = "";
    uploadInput.click();  // trigger the click of actual file upload button
}

export class UploadFile extends PureComponent {
    constructor(props) {
        super(props);

        var defaultUploadViaUriTools = [tools.htmlToPdf];

        this.state = {
            getprocessedContextIdTimeOut: 10000,
            uploadProgress: 0,
            isUrlEntry: defaultUploadViaUriTools.some((tool) => tool.id === this.props.toolInfo.id),
            uriInput: "",
            isUrlEntryValid: true,
            forceLoadingDisplay: false,
            showLoadingGif: false,
            modalProps: {
                visible: false
            }
        };

        this.resetUpload();
    }

    componentDidMount() {
        this.initializeDragAndDropArea();

        if (!config.isSnapshootingCrawlers && !config.isSnapshootingUsers) {
            if (config.ssrMode !== 1) {
                if (!(this.props.step == steps.action && this.props.uploadMore) && (window.embedded || this.props.redirectionStep == redirectionSteps.noRedirection) || this.props.processedContextId === null) {
                    /*Lo�c: refactoring -> removed the create-file-context action*/
                    //this.createFileContextAndInitAll();
                    this.props.removeAllFiles();
                    /*end-refactoring*/
                } else {
                    this.initializeFiles();
                }
            }
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
        if (this.props.toolInfo && this.props.toolInfo.pageId !== tools.scanningToPdf.id) {
            FileService.cancelRequest();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.step !== this.props.step && this.props.step === steps.upload && this.state.uploadProgress) {
            this.props.removeAllFiles();
        }
    }

    initializeFiles() {
        if (this.props.redirectionStep == redirectionSteps.beforeRedirection && this.props.toolInfo.id == this.props.redirectToWidget) {
            this.props.setRedirectionInfo(redirectionSteps.inRedirection, this.props.fileToRedirect, this.props.redirectToWidget, this.props.mainTool);
            this.uploadDone(false);
        } else if (this.props.redirectionStep == redirectionSteps.afterRedirection) {
            this.setState({ showUploadProgress: true });

            FileService.redirectOutputFile(this.props.processedContextId, this.props.fileToRedirect).then(async response => {
                FileService.removeFile(this.props.processedContextId, false, true, false).then(async () => {
                    this.props.removeFile(this.props.toolInfo.id, this.props.fileToRedirect);
                    if (response.data.success == true) {
                        const files = [];
                        for (var i = 0; i < response.data.fileIds.length; i++) {
                            files.push({
                                fileId: response.data.fileIds[i],
                                fileData: null,
                                fileName: response.data.fileNames[i],
                                index: i,
                                fileSize: null
                            });
                        }
                        this.prepareFileForToolResult(files);
                    } else {
                        this.showUploadError();
                        this.props.actionFailed(response.data.errorMessage != null ? response.data.errorMessage : i10n._VIEW_UPLOAD_GENERAL_ERROR, i10n._VIEW_UPLOAD_ERROR_TITLE);
                    }
                });
            });
            this.props.setRedirectionInfo(redirectionSteps.noRedirection, null, null, null);
        }
    }

    useContextId = (contextId) => {
        this.setState({ showUploadProgress: true });

        FileService.redirectOutputFile(contextId).then(async (response) => {
            if (this.props.step === steps.action && this.props.uploadMore) {
                if (response.data.success == true) {
                    this.nbFilesToUpload = response.data.fileId.length
                    var uploadTasks = [];
                    for (var i = 0; i < response.data.fileId.length; i++) {
                        uploadTasks.push(this.prepareFileForToolResult(response.data.fileId[i], response.data.fileName[i], null, i));
                    }
                    await Promise.all(uploadTasks);
                } else {
                    this.showUploadError();
                    this.props.actionFailed(response.data.errorMessage != null ? response.data.errorMessage : i10n._VIEW_UPLOAD_GENERAL_ERROR, i10n._VIEW_UPLOAD_ERROR_TITLE);
                }
            } else {
                FileService.removeFile(contextId, false, true, false).then(async () => {
                    if (response.data.success == true) {
                        this.props.setProcessedContextId(this.props.toolInfo.id, contextId);

                        const files = [];
                        for (var i = 0; i < response.data.fileIds.length; i++) {
                            files.push({
                                fileId: response.data.fileIds[i],
                                fileData: null,
                                fileName: response.data.fileNames[i],
                                index: i,
                                fileSize: null
                            });
                        }
                        if (this.props.uploadAvoidPreload != true) {
                            this.prepareFileForToolResult(files);
                        } else {
                            this.handleUploadResult(files, true);
                        }
                    } else {
                        this.showUploadError();
                        this.props.actionFailed(response.data.errorMessage != null ? response.data.errorMessage : i10n._VIEW_UPLOAD_GENERAL_ERROR, i10n._VIEW_UPLOAD_ERROR_TITLE);
                    }
                });
            }
        });
    }

    openFiles = (files) => {
        this.uploadFiles(files);
    }

    openFilesFromInput = (event) => {
        this.openFiles(event.target.files);
    };

    resetUpload() {
        this.nbFilesToUpload = 0;
        this.filesReady = false;
        this.fileIdsForCorrectInitialOrderHelperArray = [];
        this.setState({ showUploadProgress: false });
    }

    fatalError = (error) => {
        this.props.actionFailed(error && typeof error == "string" ? error : i10n._VIEW_UPLOAD_CANT_OPEN_FILE_ERROR);
    }

    // Upload drag and drop
    initializeDragAndDropArea() {
        document.body.ondragover = (e) => {
            e.preventDefault();
            e.stopPropagation();
        };

        document.body.ondrop = (e) => { e.preventDefault(); e.stopPropagation(); };

        let dndArea = document.getElementById("dragAndDropArea");

        dndArea.ondragenter = e => {
            e.stopPropagation();
            e.preventDefault();
            dndArea.classList.add("drag-enter");
        }

        dndArea.ondragover = (e) => {
            e.stopPropagation();
            e.preventDefault();
            dndArea.classList.add("drag-over");
        }

        dndArea.ondragleave = (e) => {
            e.stopPropagation();
            e.preventDefault();
            dndArea.classList.remove("drag-over");
            dndArea.classList.remove("drag-enter");
        }

        dndArea.ondrop = (e) => {
            if (this.props.onClick)
                this.props.onClick();

            if (this.props.pageFiles.length == 0 || this.props.uploadMore) {
                if (this.props.multipleFiles) {
                    this.uploadFiles(e.dataTransfer.files);
                }
                else {
                    this.uploadFiles([[...e.dataTransfer.files].pop()]); // just take the last one
                }
            }
        }
    }

    isFileFormatNotSupported(files) {
        return this.isFileFormatNotSupportedByFilenames(Array.from(files).map((f) => { return f.name; }));
    }

    isOnlyPdf() {
        if (!this.props.fileTypes) {
            return false;
        }

        const supportedTypes = this.props.fileTypes.ext.replace(/\s/g, "").toLowerCase().split(",");

        if (supportedTypes.length === 1 && supportedTypes[0] === fileFormats.pdf) {
            return true;
        }

        return false;
    }

    isFileFormatNotSupportedByFilenames(names, exceptArray) {
        if (!this.props.fileTypes) {
            return false;
        }
        var supportedTypes = this.props.fileTypes.ext.replace(/\s/g, "").toLowerCase().split(",");

        if (exceptArray) {
            supportedTypes = supportedTypes.filter((ext) => {
                return exceptArray.indexOf(ext) < 0;
            });
        }

        var notSupported = false;

        if (supportedTypes.indexOf("*") < 0) {
            for (var i = 0; i < names.length; ++i) {
                var fileExtension = '.' + names[i]
                    .toLowerCase().split(".").pop();

                if (supportedTypes.indexOf(fileExtension) < 0) {
                    notSupported = true;
                    break;
                }
            }
        }

        return notSupported;
    }

    // Upload from client to server
    async uploadFiles(files, retryTimer) {
        this.setState({ toolGlobalLoading: false });
        if (!this.beforeUpload()){
            return;
        }
        if (this.isFileFormatNotSupported(files)) {
            this.displayModal({
                type: "error",
                title: i10n._VIEW_UPLOAD_FILE_INVALID_FORMAT_ERROR,
                content: this.isOnlyPdf() ? i10n._VIEW_UPLOAD_UNKNOWN_DOCUMENT_FORMAT_ERROR : i10n._VIEW_TOOL_LAYOUT_UNKNOWN_DOCUMENT_FORMAT,
                className: this.props.buttonBackground
            });

            if (this.props.pageFiles.length > 0) { //for tools that accepts multiple files and user already had chosen files but have chosen wrong file format on upload more 
                this.props.onUpload({ success: false });
            }

            return;
        }

        this.fileIdsForCorrectInitialOrderHelperArray = this.props.pageFiles.map((f) => {
            return f.fileId
        });

        var filesArray = Array.from(files);

        var token = getCookie(window.antiForgeryCookie);
        var zipFilesCount = 0;

        filesArray.forEach((f) => {
            if (this.isZip(f.name)) {
                ++zipFilesCount;
            }
        });

        const fileNumber = this.fileIdsForCorrectInitialOrderHelperArray.length;
        this.nbFilesToUpload = filesArray.length - zipFilesCount;

        const userPlan = UserHelper.GetCurrentPlan();
        if (userPlan.MaxBatchUploadCount < this.nbFilesToUpload || this.props.pageFiles?.length + this.nbFilesToUpload > userPlan.MaxBatchUploadCount) {
            const shouldDisplayActionFailed = this.props.pageFiles?.length + this.nbFilesToUpload > userPlan.MaxBatchUploadCount;
            this.displayPremiumModal(i10n._VIEW_UPLOADFILE_LIMIT_EXCEEDED_CONTENT.replace("#nbfile", userPlan.MaxBatchUploadCount), !shouldDisplayActionFailed);
            return;
        }

        if (!this.beforeUpload()){
            return;
        }

        this.props.setStep(steps.upload);

        for (var i = 0; i < filesArray.length - zipFilesCount; i++) {
            this.fileIdsForCorrectInitialOrderHelperArray.push(null);
        }

        await this.uploadFile(filesArray, token, fileNumber);
    }

    showUploadError = () => {
        this.setState({ error: true });
        this.setState({ showUploadProgress: false });
    }

    onError = (message) => {
        this.resetUpload();
        if (message)
            this.setState({ errorMessage: message });
        else
            this.setState({ errorMessage: i10n._VIEW_UPLOAD_GENERAL_ERROR });
    }

    showFileSizeExceededError = () => {
        const userPlan = UserHelper.GetCurrentPlan();
        this.displayPremiumModal(i10n._VIEW_UPLOAD_FILE_TOO_LARGE_ERROR.replace('#file_size', getFormattedFileSize(userPlan.MaxUploadFileSize, 0)));
    }

    showEmptyFileError = () => {
        this.displayModal({
            type: "error",
            title: i10n._ERROR,
            content: i10n._VIEW_UPLOAD_FILE_IS_EMPTY,
            className: this.props.buttonBackground
        });
    }

    isZip(name) {
        return name.endsWith(".zip");
    }

    showZipInputWarning(skippedFiles, totalFilesNumber) {
        let fileQuantity = 0;
        const fileList = Object.values(skippedFiles).map(zipFile => zipFile.map((elem) => {
            fileQuantity++;
            return <p className="mb-0">{elem}</p>;
        }));
        var msg = (
            <div>
                <h5>{i10n._VIEW_UPLOAD_ZIP_FILE_UNSUPPORTED_SUBTITLE.replace("#zipName", Object.keys(skippedFiles).join(","))}</h5>
                <p className="mb-2">
                    {i10n._VIEW_UPLOAD_ZIP_FILE_UNSUPPORTED_CONTENT.replace("#skippedFilesLength", fileQuantity).replace("#totalFilesNumber", totalFilesNumber)}
                </p>
                <div className="small-error-content">
                    {fileList}
                </div>
            </div>
        );

        this.displayModal({
            type: "warning",
            title: i10n._VIEW_TOOL_LAYOUT_WARNING,
            content: msg,
            className: this.props.buttonBackground
        });
    }

    showUnsupportedZipError() {
        this.displayModal({
            type: "error",
            title: i10n._ERROR,
            content: i10n._VIEW_UPLOAD_ZIP_FILE_UNSUPPORTED,
            className: this.props.buttonBackground
        });
    }


    beforeUpload(files) {
        if (!UserHelper.IsUsingPaidPlan() && UserHelper.GetUsage()?.creditsLeft === 0){
            this.displayPremiumModal(i10n._VIEW_UPLOADFILE_PREMIUM_MODAL_TITLE);
            UserHelper.RefreshUsage();
            return false;
        }
        if (this.props.toolInfo.status === ToolStatus.Beta && !UserHelper.IsUsingPaidPlan()) {
            this.displayPremiumModal(i10n._VIEW_UPLOADFILE_BETA_TOOL_FOR_PREMIUM.replace("#xxx", UserHelper.GetPremiumPlan().Name), true);
            return false;
        }

        return true
    }

    onUploadCustom = (content, uploadType) => {
        switch (uploadType) {
            case "uploadTextAsHtmlFile":
                var file = new File([content], "html_input.html", { type: "text/html", lastModified: Date.now() });
                this.uploadFile([file]);
                break;

            default:
                throw "custom upload not handled: " + uploadType;
        }
    }

    async uploadSuccess(fileIds, fileNames, fileSizes, processedContextId, errorMessage, rejectedFileNames, success, uploadedFiles, linkFileIds) {
        const plan = UserHelper.GetCurrentPlan();
        if (fileSizes && fileSizes.length > 0 && fileSizes[0] > plan.MaxUploadFileSize) {
            this.showFileSizeExceededError();
            this.onError();
            return false;
        }
        if (success) {
            this.setState({ showLoadingGif: true });
            if (this.props.processedContextId != processedContextId) {
                this.props.setProcessedContextId(this.props.toolInfo.id, processedContextId);
            }

            this.nbFilesToUpload = fileNames.length;

            let files = [];
            for (let idx = 0, fileIdx = this.props.pageFiles.length; idx < fileNames.length; idx++, fileIdx++) {
                const fileName = fileNames[idx];
                // @todo: change when the server return the file name and not the full path.
                const parsedFileName = fileName.split('\\').pop().split('/').pop();
                const fileId = fileIds[idx];
                let fileData = null;
                if (uploadedFiles && linkFileIds) {
                    fileData = uploadedFiles[linkFileIds[fileId]];
                }

                files.push({
                    fileId: fileId,
                    fileData: fileData,
                    fileName: parsedFileName,
                    index: fileIdx,
                    fileSize: fileSizes[idx]
                });
            };

            if (this.props.uploadAvoidPreload != true) {
                this.prepareFileForToolResult(files);
            } else {
                await this.handleUploadResult(files, false);
            }

            const skippedFiles = [];
            for (let idx = 0; idx < rejectedFileNames.length; idx++) {
                const fileName = rejectedFileNames[idx];
                const parsedFileName = fileName.split('\\').pop().split('/').pop();
                if (fileName.indexOf('zip') !== -1) {
                    const zipFileName = fileName.split('\\')[0].split('/').pop();
                    // @todo: find a better way to keep the errors.
                    if (!skippedFiles[zipFileName])
                        skippedFiles[zipFileName] = [];
                    skippedFiles[zipFileName].push(parsedFileName);
                }
            };
            if (rejectedFileNames.length > 0) {
                let skippedFilesCount = Object.values(skippedFiles).reduce((i, sf) => i += sf.length, 0);
                if (skippedFilesCount > 0 && fileIds.length === 0 && this.props.pageFiles.length === 0) {
                    this.showUnsupportedZipError();
                    this.showUploadError();
                } else if (skippedFilesCount > 0 && fileIds.length === 0 && this.props.pageFiles.length > 0) {
                    this.showUnsupportedZipError();
                    this.uploadDone();
                    return true;
                } else if (skippedFilesCount > 0 && fileIds.length > 0) {
                    this.showZipInputWarning(skippedFiles, rejectedFileNames.length + fileNames.length);
                }
            }

            return true;
        } else {
            this.showUploadError();
            this.props.actionFailed(errorMessage != null ? errorMessage : i10n._VIEW_UPLOAD_GENERAL_ERROR, i10n._VIEW_UPLOAD_ERROR_TITLE);
            return false;
        }
    }

    goPremiumModalContent = cause => <div className="text-center">
        {
            !UserHelper.IsUsingPaidPlan() &&
            <h3 class="mt-3 bold">{i10n._VIEW_UPLOADFILE_GO_PREMIUM_MAIN_TITLE}</h3>
        }
        <div className="premium-modal-img">
            <AsyncSVG className="plan-list-icon" src="/images/avepdf-premium-visual.svg" />
        </div>
        <h3>{cause ?? i10n._VIEW_UPLOADFILE_PREMIUM_MODAL_TITLE}</h3>
        {
            UserHelper.IsUsingPaidPlan() === false &&
            <>
                <p>{i10n._VIEW_UPLOADFILE_PREMIUM_MODAL_SUBTITLE}</p>

                <p className="bold mt-5 mb-2">{i10n._VIEW_UPLOADFILE_PREMIUM_MODAL_DO_MORE}</p>

                <ul className="text-left mb-5 plan-features">
                    {
                        UserHelper.GetPremiumPlan().MaxDailyActions > 0 &&
                        <li><AsyncSVG className="plan-list-icon" src="/images/ave-check-premium.svg" />{i10n._VIEW_PRICING_PLAN_FEATURE_MAX_OPERATION} <span className="sbold">{UserHelper.GetPremiumPlan().MaxDailyActions === 0 ? "Unlimited" : UserHelper.GetPremiumPlan().MaxDailyActions}</span></li>
                        ||
                        <li><AsyncSVG className="plan-list-icon" src="/images/ave-check-premium.svg" />{i10n._VIEW_PRICING_PLAN_FEATURE_NO_MAX_OPERATION}</li>
                    }
                    <li><AsyncSVG className="plan-list-icon" src="/images/ave-check-premium.svg" />{i10n._VIEW_PRICING_PLAN_FEATURE_MAX_FILE_SIZE} <span className="sbold">{getFormattedFileSize(UserHelper.GetPremiumPlan().MaxUploadFileSize, 0)}</span></li>
                    <li><AsyncSVG className="plan-list-icon" src="/images/ave-check-premium.svg" />{i10n._VIEW_PRICING_PLAN_FEATURE_MAX_FILE_BATCH} <span className="sbold">{UserHelper.GetPremiumPlan().MaxBatchUploadCount}</span></li>
                    <li><AsyncSVG className="plan-list-icon" src="/images/ave-check-premium.svg" />{i10n._VIEW_PRICING_PLAN_FEATURE_BETA_FEATURE}</li>
                    <li><AsyncSVG className="plan-list-icon" src="/images/ave-check-premium.svg" />{i10n._VIEW_PRICING_PLAN_FEATURE_NO_ADS}</li>
                    <li><AsyncSVG className="plan-list-icon" src="/images/ave-check-premium.svg" />{i10n._VIEW_PRICING_PLAN_FEATURE_SUPPORT}</li>

                </ul>

                <div className="text-center">
                    <Link to={getLocalizedLink(sitemap.VIEW_LIST_PLAN_ROUTE)}><button className="ant-btn ant-btn-default ant-btn-buy my-2">{i10n._VIEW_PRICING_GET_STARTED_BUTTON_LABEL}</button></Link>
                </div>
            </>
        }
    </div>;

    async uploadFile(files, token, fileNumber, transferDone, isDeferred) {
        //we have lot of possible concurrent access problem here. suggestion: this function should not run asynchronously.
        this.filesReady = false;
        var fd = new FormData();
        fd.append('processedContextId', this.props.processedContextId);
        let totalFilesNumber = 0;
        let sendFiles = {};
        const plan = UserHelper.GetCurrentPlan();
        const validFiles = files.map(file => {
            const maxFileSizeFileType = getFileSizeLimit(file.name);
            if (file.size > plan.MaxUploadFileSize) {
                this.showFileSizeExceededError();
                this.onError();

                return false;
            } else if (file.size < 1) {
                this.showEmptyFileError();
                this.onError();

                return false;
            } else if (maxFileSizeFileType !== null && file.size > maxFileSizeFileType) {
                this.fatalError(i10n._VIEW_TOOL_LAYOUT_FILE_TYPE_SIZE_EXCEEDED.replace('{0}', getFileType(file.name)).replace('{1}', getFormattedFileSize(maxFileSizeFileType, 0)));
                return false;
            }
            let isZip = this.isZip(file.name);
            if (isZip)
                totalFilesNumber++;

            let fileGuid = isZip ? null : Utilities.generateGUID();
            fd.append(fileGuid, file, file.name);
            sendFiles[fileGuid] = file

            return true;
        });
        //todo: add other files to transfer here.
        if (validFiles.every(v => !v)) return;

        this.setState({ error: false, showUploadProgress: true }); //not sure we should do that, here

        const onProgress = (e) => {
            if (e.lengthComputable) {
                const percentProgress = Math.round((e.loaded * 100) / e.total);
                this.setState({ uploadProgress: percentProgress });
            }
        }

        try {
            let response = await FileService.uploadFile(fd, window.embedded ? { "X-AVEPDF-ID": Utilites.generateGUID() } : {}, onProgress);

            if (response.data.success === true) {
                const { fileIds, fileNames, fileSizes, processedContextId, rejectedFileNames, success, errorMessage, linkClientFileIds } = response.data;
                this.uploadSuccess(fileIds, fileNames, fileSizes, processedContextId, errorMessage, rejectedFileNames, success, sendFiles, linkClientFileIds);
            } else {
                throw response;
            }


        } catch (error) {
            if (error.data.errorCode === 6) {
                this.props.setStep(steps.upload);
                this.displayPremiumModal(i10n._VIEW_UPLOADFILE_PREMIUM_MODAL_TITLE);
                UserHelper.RefreshUsage();
                return;
            }
            this.showUploadError();
            var errorMessage = i10n._VIEW_UPLOAD_REQUEST_FAILED.replace("{STATUS}", error.status != null ? error.status : "UNKNOWN");

            if (error.response && error.message) {
                errorMessage = error.response.data && typeof error.response.data == "string" ?
                    error.response.data : error.message;
            }
            if (error == "Cancel" || error.statusText && error.statusText === "abort") {
                return false; //Request Aborted By Quiting
            }
            this.props.actionFailed(errorMessage, i10n._VIEW_UPLOAD_ERROR_TITLE);
            return false;
        }
    }

    displayPremiumModal(cause, shouldDisplayActionFailed = true) {
        if (window.embedded === true){
            this.fatalError(cause);
            return;
        }
        this.displayModal({
            type: null,
            title: null,
            children: this.goPremiumModalContent(cause),
            className: this.props.buttonBackground,
            onCancel: () => this.setState({ modalProps: { visible: false } }, () => shouldDisplayActionFailed && this.fatalError(cause ?? i10n._VIEW_UPLOADFILE_SUBTITLE_ERROR_EXCEED_PLAN)),
            closable: true,
            maskClosable: true,
            wrapClassName: "premium-modal-error",
            footer: null,
        });
    }

    prepareFileForToolResult = files => {
        var prepareFileForToolParams = {
            fileIds: files.map(f => f.fileId),
            processedContextId: this.props.processedContextId,
            toolId: this.props.toolInfo.id,
            pdfParameters: null
        }

        if (this.props.thumbnailConfig.mode == thumbnailMode.document) {
            prepareFileForToolParams.pdfParameters = {
                getPreview: true,
                thumbnailWidth: this.props.thumbnailConfig.width,
                thumbnailHeight: this.props.thumbnailConfig.height
            }
        }

        FileService.prepareFileForTool(prepareFileForToolParams).then((resp) => this.handlePrepareForToolResultSuccess(resp, false, files), this.handlePrepareForToolResultFailed);
    }

    checkUriEntry = async () => {
        var regEx = new RegExp(/https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,}/);
        await this.preprendUriHttp();
        return new Promise((res) => {
            var result = regEx.test(this.state.uriInput);
            this.setState({ isUrlEntryValid: result }, () => res(result))
        });
    }

    preprendUriHttp = () => {
        return new Promise((res) => {
            if (!/^(http|https):/.test(this.state.uriInput)) {
                this.setState({ uriInput: `http://${this.state.uriInput}` }, res);
            } else {
                res();
            }
        });
    }

    downloadFromUrl = async () => {
        if (!await this.checkUriEntry()) {
            return;
        }
        const url = this.state.uriInput; // URL TEST: http://www.africau.edu/images/default/sample.pdf

        this.setState({ error: false });

        if (!this.beforeUpload()){
            return;
        }

        if (typeof url === "undefined" || !url) // Check url is entered
            return false;

        if (this.props.uploadAvoidPreload === true) {
            this.props.onAddPendingRemoteFile(this.props.toolInfo.id, this.state.uriInput, this.state.uriInput.split('/').slice(3).join('/'));
            this.props.onUpload({ success: true });
            return;
        }

        this.uploadFromUri([{ uri: url }]);
    }

    uploadFromUri = async (files) => {
        if (!this.beforeUpload()){
            return;
        }
        this.props.setStep(steps.upload);

        var needPreview = this.props.toolInfo.thumbnail.mode !== thumbnailMode.none;

        this.setState({
            showUploadProgress: true,
            uploadProgress: needPreview ? 0 : 100,
            forceLoadingDisplay: needPreview
        });
        FileService.loadFromHttp({
            processedContextId: this.props.processedContextId,
            uri: files.map(file => file.uri),
            toolId: this.props.toolInfo.id,
            needPreview: needPreview,
            headers: files.map(file => file.headers),
            fileNames: files.map(file => file.fileName)
        }).then(async (response) => {
            const { fileIds, fileNames, fileSizes, processedContextId, errorMessage, rejectedFileNames, success } = response.data;
            await this.uploadSuccess(fileIds, fileNames, fileSizes, processedContextId, errorMessage, rejectedFileNames, success);
        }, this.handlePrepareForToolResultFailed);
    }

    handlePrepareForToolResultSuccess = (response, isRemoteUpload, files) => {
        var isEmpty = response.data.files?.every(file => file.success === false);
        if (response.data.success == true && isEmpty === false) {
            let prepareFilesResult = response.data.files;
            this.handleUploadResult(prepareFilesResult, isRemoteUpload, files);
        }
        else if (response.data.success == true && isEmpty === true) {
            this.showUploadError();
            if (response.data.files && response.data.files.length > 0) {
                let errMessage = response.data.files.map(file => file.errorMessage);
                this.props.actionFailed(errMessage, i10n._VIEW_UPLOAD_CANT_OPEN_FILE_ERROR);
            } else {
                this.props.actionFailed(i10n._VIEW_UPLOAD_FILE_IS_EMPTY, i10n._VIEW_UPLOAD_CANT_OPEN_FILE_ERROR);
            }
            return false;
        }
        else {
            this.showUploadError();
            this.props.actionFailed(response.data.errorMessage != null ? response.data.errorMessage : i10n._VIEW_UPLOAD_GENERAL_ERROR, i10n._VIEW_UPLOAD_ERROR_TITLE);
            return false;
        }
    }

    handlePrepareForToolResultFailed = (error) => {
        this.showUploadError();
        var errorMessage = i10n._VIEW_UPLOAD_REQUEST_FAILED.replace("{STATUS}", error.status != null ? error.status : "UNKNOWN");

        if (error.response && error.message) {
            errorMessage = error.response.data && typeof error.response.data == "string" ?
                error.response.data : error.message;
        }

        if (error == "Cancel" || error.statusText && error.statusText === "abort") {
            return false; //Request Aborted By Quiting
        }
        this.props.actionFailed(errorMessage, i10n._VIEW_UPLOAD_ERROR_TITLE);
        return false;
    }

    handleUploadResult = async (fileUploadResults, isRemoteUpload, fileReferences = null) => {
        if (fileReferences !== null) {
            this.fileIdsForCorrectInitialOrderHelperArray = fileReferences.map(file => file.fileId);
        }

        const filePreviewTask = fileUploadResults.map(fileUploadResult => {
            let fileData = fileUploadResult.fileData;
            if ((!fileData || fileData === null) && fileReferences) {
                let fileRef = fileReferences.find(f => f.fileId === fileUploadResult.uploadedFileId);
                if (fileRef) {
                    fileData = fileRef.fileData;
                }
            }

            const onPreviewReady = async fileDataTask => {
                const fileData = await fileDataTask;
                this.props.onFileUploaded(this.props.toolInfo.id, fileUploadResult.fileName, fileData, fileUploadResult.fileSize, fileUploadResult.uploadedFileId ?? fileUploadResult.fileId, fileUploadResult.pageCount ?? null, false, fileUploadResult.thumbnailsData);

                if (fileUploadResult.hasPassword === true) {
                    this.props.fileNeedRedirection(this.props.toolInfo.id, fileUploadResult.uploadedFileId);
                }
            }

            if ((fileData === null || isRemoteUpload === true) && this.props.toolInfo.thumbnail.mode !== thumbnailMode.none) {
                return onPreviewReady(this.prepareRemoteFileForPreview(fileUploadResult.fileId, fileUploadResult.index));
            } else if (fileData && fileData !== null) {
                return onPreviewReady(fileData.arrayBuffer());
            } else {
                return onPreviewReady(Promise.resolve(null));
            }
        });

        await Promise.all(filePreviewTask);

        if (this.fileIdsForCorrectInitialOrderHelperArray.length > 1) {
            this.props.reorderUploadedFiles(this.props.toolInfo.id, this.fileIdsForCorrectInitialOrderHelperArray);
        }

        var filesToUnlock = this.props.pageFiles.filter(f => f.redirectionNeeded);


        if (filesToUnlock.length > 0 && !this.props.toolAcceptsPasswordProtectedFiles) {
            this.props.actionFailed(i10n._VIEW_TOOL_LAYOUT_PDF_OPERATION_NOT_ALLOWED, i10n._VIEW_UPLOAD_ERROR_TITLE, false);
            if (!window.embedded)
                this.props.setRedirectionInfo(redirectionSteps.beforeRedirection, filesToUnlock[0].fileId, tools.unlock.id, this.props.toolInfo.id);
            return false;
        }

        this.uploadDone();
    }

    uploadDone = (skipTimer = false) => {
        if (skipTimer) {
            this.props.onUpload({ success: true });
        } else {
            this.setState({
                uploadProgress: 100,
            });

            this.timer = setTimeout(() => {
                this.setState({
                    showUploadProgress: false,
                    uploadProgress: 0
                });

                this.props.onUpload({ success: true });

            }, 300);
        }
    }

    prepareRemoteFileForPreview = async (fileId, fileQuantity) => {

        this.setState({ forceLoadingDisplay: false });

        var previewDownladProgressHandler = (e) => {
            if (!this.state.showLoadingGif) {
                var percentProgress = Math.round((e.loaded * (100 / fileQuantity)) / e.total);
                this.setState({ uploadProgress: this.state.uploadProgress + percentProgress });
            }
        }

        try {
            var response = await FileService.downloadPreview(this.props.processedContextId, fileId, previewDownladProgressHandler);
            if (response.status === 200) {
                const stream = await response.data.arrayBuffer();
                return new Uint8Array(stream)
            }
            else {
                throw response.statusText;
            }
        }
        catch (err) {
            console.error(err);
        }

        return null;
    }

    displayModal = ({ title, content, type, className, ...opts }) => {
        let icon;
        switch (type) {
            case "info":
                icon = React.createElement(InfoCircleOutlined, { style: { color: '#1caaff' } });
                break;
            case "warning":
                icon = React.createElement(WarningOutlined, { style: { color: '#ec840d' } });
                break;
            case "error":
                icon = React.createElement(CloseCircleOutlined, { style: { color: '#cc3723' } });
                break;
            default:
                icon = null;
        }

        let modalTitle = icon && title ? <>{icon} {title}</> : null;

        let classNameModalProps = `${className} ${type !== undefined ? 'simple-modal-error-wrapper' : ''}`

        this.setState({
            modalProps: {
                visible: true,
                title: modalTitle,
                onOk: () => this.setState({ modalProps: { visible: false } }),
                className: classNameModalProps,
                children: content,
                closable: false,
                cancelButtonProps:{ style: { display: 'none' } },
                ...opts
            }
        });
    }

    linkInput = createRef();

    render() {
        const className = this.props.fileDroped ? "droped" : "";
        let folderUploadButton = this.props.multipleFiles ? i10n._VIEW_UPLOAD_FILE_CHOOSE_MULT : i10n._VIEW_UPLOAD_FILE_CHOOSE;
        const userPlan = UserHelper.GetCurrentPlan();
        const maxFileSize = this.props.fileTypes?.fileLimit ?? userPlan.MaxUploadFileSize;

        return (
            <div className="w-100" onClick={() => this.props.onClick && this.props.onClick()}>
                <input
                    ref={(ref) => { uploadInput = ref }}
                    id="files"
                    name="files"
                    type="file"
                    accept={this.props.fileTypes?.ext}
                    size={1}
                    onChange={this.openFilesFromInput}
                    multiple={this.props.multipleFiles}
                />
                {
                    (this.props.step == steps.action && this.props.uploadMore && !this.state.showUploadProgress) &&
                    <div className="text-center upload-more-with-action">
                        <UploadMoreButton
                            beforeClick={this.props.uploadMore.beforeClick}
                            afterClick={() => { this.props.setUploadWindowTrigger(true); }}
                            multipleFiles={this.props.multipleFiles}
                            fileTypes={this.props.fileTypes}
                            folderUploadButton={folderUploadButton}
                            onFilesChosen={this.uploadFromUri}
                            onError={this.fatalError}
                            showUploadViaURI={true}
                            onUriInputChange={(uri) => this.setState({ uriInput: uri })}
                            downloadFromUrl={this.downloadFromUrl}
                        />
                        {
                            this.props.uploadMore.actionButton
                        }
                    </div>
                    ||
                    <div className="col-md-12 upload-file-wrapper">
                        <div className="row">
                            <div className="col-md-12">
                                <div id="upload" className="tools-upload">
                                    {
                                        this.state.showLoadingGif || this.state.toolGlobalLoading &&
                                        <div className="loading-tool">
                                            <AsyncSVG className="loading-icon rounded-icon" src="/images/black-avepdf-svg-loading.svg" />
                                        </div>
                                    }
                                    {
                                        !this.state.showUploadProgress &&
                                        !this.state.toolGlobalLoading &&
                                        !this.props.onlineUpload &&
                                        <div className="downloaded-wrapper d-flex align-content-stretch justify-content-center row">
                                            <div className="upload-container">
                                                {this.props.toolInfo.view === 'tabs' &&
                                                    <Tabs className="avepdf-upload-tabs" type="card" defaultActiveKey={this.props.defaultUploadOpen}>
                                                        <TabPane tab={i10n._VIEW_UPLOAD_FILE_CHOOSE_TAB} key="upload-file">
                                                            <div className="text-center">
                                                                <div className="file-upload-option-wrapper">
                                                                    <div className="file-upload-option d-block d-md-inline-block element-with-tooltip">
                                                                        <Tooltip className="upload-tooltip-wrapper" borderClassName="tooltip-border" text={i10n._VIEW_UPLOAD_UPLOAD_FROM_DEVICE} />
                                                                        <div>
                                                                            <Button aria-label="Upload Folder" className={`action-button choose-file-btn`} onClick={uploadFileClick} type="primary">
                                                                                <AsyncSVG className="cloud-upload-icon" src="/images/upload-folder.svg" />
                                                                                <span>{this.props.uploadButton || (this.props.multipleFiles ? i10n._VIEW_UPLOAD_FILE_CHOOSE_MULT : i10n._VIEW_UPLOAD_FILE_CHOOSE)}</span>
                                                                            </Button>
                                                                        </div>
                                                                    </div>
                                                                    {
                                                                        !window.embedded && 
                                                                        <div className="file-upload-option element-with-tooltip">
                                                                        <Tooltip className="upload-tooltip-wrapper cloud-upload-tooltip-wrapper" borderClassName="tooltip-border" text={i10n._VIEW_UPLOAD_UPLOAD_FROM_GOOGLEDRIVE} />
                                                                        <GooglePicker
                                                                            buttonBackground={this.props.buttonBackground}
                                                                            multiselect={this.props.multipleFiles}
                                                                            types={this.props.fileTypes?.ext}
                                                                            onFilesPicked={this.uploadFromUri}
                                                                            onError={this.fatalError}
                                                                            />
                                                                        </div>
                                                                    }
                                                                    <div className="file-upload-option element-with-tooltip">
                                                                        <Tooltip className="upload-tooltip-wrapper cloud-upload-tooltip-wrapper" borderClassName="tooltip-border" text={i10n._VIEW_UPLOAD_UPLOAD_FROM_DROPBOX} />
                                                                        <DropboxChooser
                                                                            buttonBackground={this.props.buttonBackground}
                                                                            multiselect={this.props.multipleFiles}
                                                                            extensionsArray={this.props.fileTypes?.ext}
                                                                            onFilesDownloaded={this.uploadFromUri}
                                                                            onError={this.fatalError}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="tool-action-sub-title ">{this.props.subtitle || (i10n._VIEW_UPLOAD_FILE_MAX_FILE_SIZE_MB ? i10n._VIEW_UPLOAD_FILE_MAX_FILE_SIZE_MB.replace("#sizeInMB", getFormattedFileSize(maxFileSize, 0, true)) : null)}</div>
                                                            </div>

                                                        </TabPane>
                                                        <TabPane tab={i10n._VIEW_UPLOAD_UPLOAD_FROM_REMOTE} key="upload-uri">
                                                            <Input
                                                                className={`${!this.state.isUrlEntryValid ? "uri-input-invalid" : ""} upload-url-input`}
                                                                type="text"
                                                                ref={ref => this.linkInput = ref}
                                                                onChange={(e) => this.setState({ uriInput: e.target.value })}
                                                                minLength={1}
                                                                placeholder={this.props.toolInfo.customUriPlaceholder ? this.props.toolInfo.customUriPlaceholder : "https://www.example.com/file.pdf"}
                                                                addonBefore={<div className="url-input-icon"><FontAwesomeIcon icon={faGlobe} size="2x" title="world wide web" /></div>}
                                                                addonAfter={
                                                                    <div className="rename-on">
                                                                        <Button className="ant-btn-primary" onClick={this.downloadFromUrl}><FontAwesomeIcon icon={faCheck} size="1x" title="validate" /></Button>
                                                                    </div>
                                                                }
                                                                onPressEnter={this.downloadFromUrl}
                                                            />
                                                        </TabPane>
                                                        {
                                                            Array.isArray(this.props.toolInfo.additionalUploadMethod) && this.props.toolInfo.additionalUploadMethod.includes("html-text")
                                                            &&
                                                            <TabPane tab={i10n._VIEW_UPLOAD_UPLOAD_FROM_HTML_CODE} key="tab-html-text">
                                                                <TextArea
                                                                    className="upload-html-input"
                                                                    rows={16}
                                                                    ref={ref => this.htmlText = ref}
                                                                    placeholder={'<!DOCTYPE html>\n<html lang="' + this.props.lang + '">\n<head>\n' +
                                                                        '<meta content="width=device-width, initial-scale=1.0" name="viewport">\n<meta charset="utf-8">\n</head>\n</html>'} />
                                                                <Button
                                                                    className="ant-btn-primary mt-3"
                                                                    onClick={() => this.onUploadCustom(this.htmlText.resizableTextArea.textArea.value, "uploadTextAsHtmlFile")}>
                                                                    {i10n._VIEW_TEXTTOPDF_CONVERT_BUTTON}
                                                                </Button>
                                                            </TabPane>
                                                        }
                                                    </Tabs>
                                                    ||
                                                    <Fragment>
                                                        <div className="tool-action-title">{this.props.uploadTitle || (this.props.multipleFiles ? i10n._VIEW_UPLOAD_FILE_DROP_MULT : i10n._VIEW_UPLOAD_FILE_DROP)}</div>
                                                        {
                                                            !this.state.isUrlEntry &&
                                                            <div className="text-center">
                                                                <div className="file-upload-option-wrapper">
                                                                    <div className="file-upload-option d-block d-md-inline-block element-with-tooltip">
                                                                        <Tooltip className="upload-tooltip-wrapper" borderClassName="tooltip-border" text={i10n._VIEW_UPLOAD_UPLOAD_FROM_DEVICE} />
                                                                        <Button aria-label="Upload Folder" className={`action-button choose-file-btn`} onClick={uploadFileClick} >
                                                                            <span>
                                                                                <AsyncSVG className="cloud-upload-icon" src="/images/upload-folder.svg" />
                                                                                <span>{this.props.uploadButton || (this.props.multipleFiles ? i10n._VIEW_UPLOAD_FILE_CHOOSE_MULT : i10n._VIEW_UPLOAD_FILE_CHOOSE)}</span>
                                                                            </span>
                                                                        </Button>
                                                                    </div>
                                                                    {
                                                                        !window.embedded && 
                                                                        <div className="file-upload-option element-with-tooltip">
                                                                            <Tooltip className="upload-tooltip-wrapper" borderClassName="tooltip-border" text={i10n._VIEW_UPLOAD_UPLOAD_FROM_GOOGLEDRIVE} />
                                                                            <GooglePicker
                                                                                buttonBackground={this.props.buttonBackground}
                                                                                multiselect={this.props.multipleFiles}
                                                                                types={this.props.fileTypes?.ext}
                                                                                onFilesPicked={this.uploadFromUri}
                                                                                onError={this.fatalError}
                                                                            />
                                                                        </div>
                                                                    }
                                                                    <div className="file-upload-option element-with-tooltip">
                                                                        <Tooltip className="upload-tooltip-wrapper" borderClassName="tooltip-border" text={i10n._VIEW_UPLOAD_UPLOAD_FROM_DROPBOX} />
                                                                        <DropboxChooser
                                                                            buttonBackground={this.props.buttonBackground}
                                                                            multiselect={this.props.multipleFiles}
                                                                            extensionsArray={this.props.fileTypes?.ext}
                                                                            onFilesDownloaded={this.uploadFromUri}
                                                                            onError={this.fatalError}
                                                                        />
                                                                    </div>
                                                                    <div className="file-upload-option element-with-tooltip" onClick={() => this.setState({ isUrlEntry: !this.state.isUrlEntry })}>
                                                                        <Tooltip className="upload-tooltip-wrapper" borderClassName="tooltip-border" text={i10n._VIEW_UPLOAD_UPLOAD_FROM_REMOTE} />
                                                                        <URLChooser
                                                                            buttonBackground={this.props.buttonBackground}
                                                                        />
                                                                    </div>
                                                                </div>

                                                                {
                                                                    this.props.proceseedContentAvailable.length > 0 &&
                                                                    <div className="element-with-tooltip ave-processed-file">
                                                                        <div className="d-inline-block">
                                                                            <Tooltip
                                                                                className="upload-tooltip-wrapper cloud-upload-tooltip-wrapper"
                                                                                borderClassName="tooltip-border"
                                                                                text={this.isFileFormatNotSupportedByFilenames([this.props.proceseedContentAvailable[0].outputFileName]) ?
                                                                                    i10n._VIEW_UPLOAD_FILE_INVALID_FORMAT_ERROR :
                                                                                    i10n._VIEW_UPLOAD_UPLOAD_FROM_LASTFILE_TOOLTIP.replace("{0}", tools[Object.keys(tools).find(t => tools[t].id === this.props.proceseedContentAvailable[0].toolId)].title())}
                                                                            />

                                                                            <Button
                                                                                aria-label="File Available"
                                                                                className={`action-button`}
                                                                                onClick={() => this.useContextId(this.props.proceseedContentAvailable[0].id)}
                                                                                disabled={this.isFileFormatNotSupportedByFilenames([this.props.proceseedContentAvailable[0].outputFileName])}>

                                                                                <p className="file-description">
                                                                                    <FontAwesomeIcon className="mr-2 ave-file-icon" icon={faFile} />
                                                                                    <span className="file-name">{this.props.proceseedContentAvailable[0].outputFileName}</span>
                                                                                    <span className="file-size">( {getFormattedFileSize(this.props.proceseedContentAvailable[0].outputSize)} )</span>
                                                                                </p>

                                                                            </Button>
                                                                        </div>
                                                                    </div>
                                                                }
                                                                <div className="tool-action-sub-title ">
                                                                    {
                                                                        this.props.subtitle || (i10n._VIEW_UPLOAD_FILE_MAX_FILE_SIZE_MB ?
                                                                            i10n._VIEW_UPLOAD_FILE_MAX_FILE_SIZE_MB.replace("#sizeInMB", getFormattedFileSize(userPlan.MaxUploadFileSize, 0, true)) :
                                                                            null)
                                                                    }
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            this.state.isUrlEntry &&
                                                            <Input
                                                                className={`${!this.state.isUrlEntryValid ? "uri-input-invalid" : ""} upload-url-input`}
                                                                type="text"
                                                                ref={ref => this.linkInput = ref}
                                                                onChange={(e) => this.setState({ uriInput: e.target.value })}
                                                                minLength={1}
                                                                placeholder={"https://www.example.com/file.pdf"}
                                                                addonBefore={<div className="url-input-icon"><FontAwesomeIcon icon={faGlobe} size="2x" title="world wide web" /></div>}
                                                                addonAfter={
                                                                    <div className="rename-on">
                                                                        <Button className="url-cancel-btn" onClick={() => this.setState({ isUrlEntry: false })}><FontAwesomeIcon icon={faTimes} size="1x" title="abort" /></Button>
                                                                        <Button className="ant-btn-primary" onClick={this.downloadFromUrl}><FontAwesomeIcon icon={faCheck} size="1x" title="validate" /></Button>
                                                                    </div>
                                                                }
                                                                onPressEnter={this.downloadFromUrl}
                                                            />
                                                        }

                                                    </Fragment>
                                                }
                                            </div>
                                        </div>

                                    }
                                    {
                                        this.state.error &&
                                        <div className="d-flex align-items-center align-content-stretch justify-content-center">
                                            <span className="text-danger pt-5">{this.state.errorMessage}</span>
                                        </div>
                                    }
                                    {
                                        this.state.showUploadProgress &&
                                        <div>
                                            <div className="d-flex align-items-center align-content-stretch justify-content-center row">
                                                <AsyncSVG className={`upload-icon rounded-icon ${className}`} src="/images/black-avepdf-svg-upload.svg" />
                                                <div className="upload-in-progress">
                                                    <div className="tool-action-title">{i10n._VIEW_UPLOAD_FILE_LOADING}</div>
                                                    <div className="tool-action-sub-title ">{i10n._VIEW_UPLOAD_COULD_TAKE_SOME_TIME}</div>
                                                </div>

                                            </div>
                                            <div className="upload-progress-wrapper">
                                                <Progress
                                                    percent={this.state.uploadProgress}
                                                    showInfo={!this.state.forceLoadingDisplay}
                                                    className={`upload-progress`} />
                                                <AsyncSVG style={{ display: this.state.forceLoadingDisplay || this.state.uploadProgress > 99 ? 'inline' : 'none' }} className="upload-progress-loading" src="/images/black-avepdf-svg-loading.svg" />
                                                <p className="upload-progress-almost-there">{this.state.uploadProgress > 99 ? i10n._VIEW_TOOL_LAYOUT_UPLOAD_ALMOST_THERE : " "}</p>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <Modal centered okType="primary" {...this.state.modalProps}></Modal>
            </div>
        );
    }
};

const mapState = ({ tool, files }) => {
    return {
        triggerUploadWindow: tool.triggerUploadWindow,
        pageFiles: files.files,
        waitingFiles: files.inQueueFiles,
        step: tool.step,
        processedContextId: files.processedContextId,
        fileToRedirect: files.fileToRedirect,
        redirectionStep: files.redirectionStep,
        redirectToWidget: files.redirectToWidget,
        mainTool: files.mainTool,
        lang: tool.lang,
        importExtensions: window.AvePDFAppState.ImportExtensions,
        fileId: files.fileId,
        proceseedContentAvailable: files.processedContext
    };
}

const mapDispatch = (dispatch) => {
    return {
        setUploadWindowTrigger(flag) {
            dispatch(onSetUploadWindowTrigger(flag));
        },
        setProcessedContextId(pageId, id) {
            dispatch(onGetProcessedContextId({ pageId: pageId, id: id }));
        },
        setStep(step) {
            dispatch(onSetToolAction(step));
        },
        actionFailed(message, title, isWarning) {
            dispatch(onActionFailed(message, title, isWarning));
        },
        fileNeedRedirection(pageId, fileId) {
            dispatch(onFileNeedRedirection({ pageId: pageId, fileId: fileId }));
        },
        onAddPendingRemoteFile(pageId, fileUrl, name) {
            dispatch(onAddPendingRemoteFile(
                {
                    pageId,
                    fileUrl,
                    name
                }
            ))
        },
        removeFile(pageId, fileId) {
            dispatch(onRemoveFile(
                {
                    pageId,
                    fileId
                }
            ));
        },
        reorderUploadedFiles(pageId, orderedfileIds) {
            dispatch(onReorderUploadedFiles({ pageId: pageId, orderedfileIds: orderedfileIds }));
        },
        setRedirectionInfo(step, fileToRedirect, redirectToWidget, mainTool) {
            dispatch(onSetRedirectionInfo(step, fileToRedirect, redirectToWidget, mainTool));
        },
        onFileUploaded(pageId, fileName, uint8ArrayFileData, fileSize, fileId, pageCount, replace, thumbnailsData) {
            dispatch(onFileUploaded(
                {
                    pageId,
                    fileName,
                    uint8ArrayFileData,
                    fileSize,
                    fileId,
                    pageCount,
                    replace,
                    thumbnailsData
                }
            ));
        },
        onRemoteFileUploaded(pageId, fileName, uint8ArrayFileData, fileSize, fileId, pageCount, replace, thumbnailsData) {
            dispatch(onRemoteFileUploaded(
                {
                    pageId,
                    fileName,
                    uint8ArrayFileData,
                    fileSize,
                    fileId,
                    pageCount,
                    replace,
                    thumbnailsData
                }
            ));
        },
        removeAllFiles() {
            dispatch(onRemoveAllFiles());
        }
    }
}


const UploadFileContainer = connect(mapState, mapDispatch)(UploadFile);
export default UploadFileContainer;